export const TABLE_ROW_IDS = [
  'BS178',
  'BS174',
  'BS175',
  'BS180',
  'BS181',
  'FA156',
  'FA031',
]

export const PIECHART_KEY = [
  { id: 'FA032', color: '#006AA6' },
  { id: 'FA033', color: '#FFCD60' },
  { id: 'FA034', color: '#D96383' },
  { id: 'FA035', color: '#74B49A' },
  { id: 'FA036', color: '#F49966' },
]

export const TREND_DATA = [
  { value: 'BS178', color: '#006AA6', isBarChart: true },
  { value: 'BS174', color: '#F5CBA3', isBarChart: true },
  { value: 'BS175', color: '#D96383', isBarChart: true },
  { value: 'BS180', color: '#C3D785', isBarChart: true },
  { value: 'BS181', color: '#AE93E1', isBarChart: true },
  { value: 'FA031', color: '#00A8B5', isLineChart: true },
]
